import { errorlog } from '@/libs/error-logs';

import { GET, POST } from './base/index';
import { ENDPOINTS } from './endpoints';
import { StandardResponse } from './standard-response';

// Types for 2FA responses
export type TwoFactorGenerateData = {
  secret: string;
  qr_code: string;
};

export type TwoFactorStatusData = {
  enabled: boolean;
};

export type TwoFactorVerifyResponse = {
  'Access Key': string;
  two_factor_auth_enabled: boolean;
};

// Request types
export type TwoFactorVerificationRequest = {
  verification_code: string;
};

export type TwoFactorVerifyRequest = {
  verification_code: string;
  pre_auth_token: string;
};

export async function twoFactorGenerateQRCode() {
  try {
    const { data, error } = await GET<StandardResponse<TwoFactorGenerateData>>(
      ENDPOINTS.TWO_FACTOR_GENERATE
    );
    if (error) {
      throw new Error();
    }

    return data;
  } catch (e) {
    const error = e as Error;
    errorlog(
      error,
      'src/api/two-factor-auth/twoFactorGenerateQRCode',
      'Error generating 2FA QR code'
    );
    return Promise.reject(error);
  }
}

export async function twoFactorEnable(verification_code: string) {
  const request: TwoFactorVerificationRequest = { verification_code };
  const { data, error } = await POST<StandardResponse<TwoFactorStatusData>>(
    ENDPOINTS.TWO_FACTOR_ENABLE,
    request
  );
  if (error) {
    return { enabled: false } as TwoFactorStatusData;
  }

  return data;
}

export async function twoFactorDisable(verification_code: string) {
  const request: TwoFactorVerificationRequest = { verification_code };
  const { data, error } = await POST<StandardResponse<TwoFactorStatusData>>(
    ENDPOINTS.TWO_FACTOR_DISABLE,
    request
  );

  if (error) {
    return { enabled: true } as TwoFactorStatusData;
  }

  return data;
}

export async function twoFactorVerify(verification_code: string, pre_auth_token: string) {
  const request: TwoFactorVerifyRequest = { verification_code, pre_auth_token };
  const response = await POST<TwoFactorVerifyResponse>(ENDPOINTS.TWO_FACTOR_VERIFY, request);
  return response;
}
